<template>
  <div class="orm-background--cta1">
    <div class="orm-container">
      <div class="orm-row">
        <div class="orm-col-xs-12">
          <div v-if="carGroup.length > 0">
            <div v-for="car in carGroup" :key="car.id">
              <template v-if="car.text_web">
                <div v-if="$route.params.name === slugMe(car.text_web)">
                  <teleport to="#crentCarDetailHeadline"
                    ><span v-html="car.text_web"></span
                  ></teleport>
                  <teleport to="#crentCarDetailSubline"
                    ><span v-html="car.description_web"></span
                  ></teleport>
                  <teleport to="#crentCarDetailBodytext"
                    ><span v-html="car.category_text"></span
                  ></teleport>
                  <teleport to="#crentCarDetailEquipment">
                    <EquipIcon :data="car.features" />
                  </teleport>
                  <teleport to="#crentCarDetailImages"
                    ><Slider v-if="car.images" :images="car.images" />
                  </teleport>
                  <teleport to="#crentCarDetailPriceMonthly"
                    ><CalcPrice
                      :car="car"
                      no-wrapper
                      @settarif="getTarif($event)"
                    />
                  </teleport>
                  <teleport to="#crentCarDetailReservatebutton" v-if="tarif"
                    ><button
                      class="orm-btn orm-btn--outline"
                      @click="select(car)"
                    >
                      {{ i18n("modules/carcategory/button") }}
                    </button>
                  </teleport>

                  <SearchBar />
                </div>
              </template>
            </div>
          </div>
          <div
            v-if="carGroup.length == 0"
            style="height: 400px"
            class="orm-row orm-pb-60 center-xs"
          >
            <div class="orm-preload-page">
              <i class="fa fa-spinner-third orm-rotate360"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";

import { slugMe } from "@/constants/formater";
import Slider from "@/components/ui/image-slider.vue";
import SearchBar from "@/components/widgets/SearchBar.vue"; // @ is an alias to /src
import EquipIcon from "@/components/reservation/equip-icon.vue";
import CalcPrice from "@/components/ui/slider/calcPrice.vue";
import i18n from "@/mixins/mixins";

export default {
  props: ["name"],
  mixins: [i18n],
  components: { EquipIcon, Slider, SearchBar, CalcPrice },
  data() {
    return {
      carGroup: [],
      stations: null,
      slugMe,
      tarif: null,
    };
  },
  setup() {
    const sttype = document.getElementById("crentReservation").dataset
      .stationtype;
    if (
      !store.getters["userSession/GET_STATIONTYPE"] ||
      (sttype !== "ALL" &&
        sttype !== !store.getters["userSession/GET_STATIONTYPE"])
    ) {
      store.dispatch(
        "userSession/SET_STATION",
        store.getters["stations/GET_STATIONS_FILTERED"][sttype][0].id
      );
    }
  },
  async mounted() {
    // const page '= document.getElementById("crentReservation");
    await store.dispatch("cargroup/SET_CARGROUPS_ALL");
    // const sttype = page.dataset.stationtype;
    this.carGroup = await store.getters["cargroup/GET_GLOBAL_CARGROUPS"];
  },
  methods: {
    getTarif(tarif) {
      this.tarif = tarif;
    },
    select(car) {
      store.dispatch("userSession/SET_CARGROUP", car.id).then(() => {
        store
          .dispatch("reservation/SET_RESERVATION_TARIFS", this.tarif)
          .then(() => {
            window.location.href =
              process.env.VUE_APP_BASE_URL +
              process.env.VUE_APP_RESERVATION_PATH +
              process.env.VUE_APP_RESERVATION_PATH_STEP2;
          });
      });
    },
  },
};
</script>
